import { BASE_URL } from "../config/env";

const API_BASE_URL = `${String(BASE_URL).replace(/\/+$/, "")}/api`;

export async function apiPost(endpoint, payload) {
  const response = await fetch(`${API_BASE_URL}/${endpoint}`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  });

  const res = await response.json();
  if (!response.ok || res.status_code !== 200) {
    throw new Error(res.message || "Request failed");
  }
  return res;
}
